import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";

type Props = {
  totalCount: number;
  totalPrice: number;
};

export default function ShopCartTotal({ totalCount, totalPrice }: Props) {
  const { t } = useTranslation("shop");

  return (
    <div className="flex justify-between mb-5">
      <div>
        <p className="mb-1.5 text-20 font-bold text-accent-solid">{formatPrice(totalPrice)}₽</p>
        <p className="text-15 font-medium">{t("cart.totalPrice")}</p>
      </div>
      <div className="text-end">
        <p className="mb-1.5 text-20 font-bold">{totalCount}</p>
        <p className="text-15 font-medium opacity-50">{t("cart.totalCount")}</p>
      </div>
    </div>
  );
}
